import { getFirestore } from "@firebase/firestore";
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { FIREBASE_CONFIG_ADMIN, FIREBASE_CONFIG_DEV } from "./config";

export const isDevel = () =>
  import.meta.env.VITE_API_URI !== "https://admin.skillster.se";
export const app = initializeApp(
  isDevel() ? FIREBASE_CONFIG_DEV : FIREBASE_CONFIG_ADMIN
);
export const db = getFirestore(app);
export const auth = getAuth();
